import { normalizeUsStateCode } from './usStateNormalize';

export type AddressFields = {
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
};

export type SavedAddressRow = AddressFields & {
  id?: string | number;
  addressid?: string | number;
  address_name?: string | null;
};

/** US ZIP for comparison: 5 digits only (drops ZIP+4). */
export function normalizeUsZipCodeFiveDigits(zip: string): string {
  const trimmed = (zip || '').trim();
  const m = trimmed.match(/^(\d{5})/);
  return m ? m[1] : trimmed;
}

const collapseWhitespace = (value: string) => value.trim().replace(/\s+/g, ' ');

export function normalizeAddressKey(fields: AddressFields): string {
  const address = collapseWhitespace((fields.address || '').toLowerCase());
  const city = collapseWhitespace((fields.city || '').toLowerCase());
  const state = normalizeUsStateCode((fields.state || '').trim()).toLowerCase();
  const zipcode = normalizeUsZipCodeFiveDigits(
    fields.zipcode || ''
  ).toLowerCase();
  return `${address}|${city}|${state}|${zipcode}`;
}

export function findDuplicateSavedAddress(
  savedList: SavedAddressRow[],
  candidate: AddressFields,
  options?: { excludeId?: string | number | null }
): SavedAddressRow | null {
  const exclude = options?.excludeId != null ? String(options.excludeId) : null;
  const candidateKey = normalizeAddressKey(candidate);
  if (!candidateKey.replace(/\|/g, '').length) {
    return null;
  }

  for (const row of savedList) {
    const raw = row.id ?? row.addressid;
    const rowId =
      raw === null || raw === undefined || raw === '' ? null : String(raw);
    if (exclude && rowId === exclude) {
      continue;
    }
    if (normalizeAddressKey(row) === candidateKey) {
      return row;
    }
  }
  return null;
}

export function duplicateAddressMessage(existing: SavedAddressRow): string {
  const label = (existing.address_name || '').trim() || 'a saved address';
  return `This address is already saved as "${label}".`;
}
